import React from 'react';
import { DarwinFlex } from 'components/darwin-ui';
import { DownloadTemplate } from './DownloadTemplate';
import { UploadFile } from './UploadFile';
import styles from './index.module.css';
import { ProcessBlockData } from 'types/processBlockTypes';

interface ActionsBarProps {
  processBlock?: ProcessBlockData;
  traceabilityPlanId: string;
  formId: string;
  formName: string;
  processMapName: string;
  processName: string;
  environment: string;
  dataSourceId: string;
  showUpload?: boolean;
  showDownload?: boolean;
}

export const ActionsBar = ({
  processBlock,
  traceabilityPlanId,
  formId,
  formName,
  processMapName,
  processName,
  environment,
  dataSourceId,
  showUpload = true,
  showDownload = true,
}: ActionsBarProps) => {
  return (
    <DarwinFlex className={styles.actionsBar} align="center">
      {showDownload && <DownloadTemplate processBlock={processBlock} />}

      {showUpload && (
        <UploadFile
          traceabilityPlanId={traceabilityPlanId}
          formId={formId}
          formName={formName}
          processMapName={processMapName}
          processName={processName}
          environment={environment}
          dataSourceId={dataSourceId}
        />
      )}
    </DarwinFlex>
  );
};
